import MakeModelFilter from "./MakeModelFilter"

export default  MakeModelFilter;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/CarAdvancedFilter/filters/MakeModelFilter/index.js